var _path, _circle, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _rect, _path2, _path3, _g11, _g12, _g13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 542,
    height: 451,
    viewBox: "0 0 542 451",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245 451C359.875 451 453 357.875 453 243C453 128.125 359.875 35 245 35C130.125 35 37 128.125 37 243C37 357.875 130.125 451 245 451ZM245 346.999C302.437 346.999 349 300.436 349 242.999C349 185.561 302.437 138.999 245 138.999C187.562 138.999 141 185.561 141 242.999C141 300.436 187.562 346.999 245 346.999Z",
    fill: "#EEEFF2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 245,
    cy: 242,
    r: 124.5,
    stroke: "#009D81"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_356_3625)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 136,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.5,
    y: 136.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#009D81",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 143,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#009D81"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_356_3625)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 350,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.5,
    y: 350.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#009D81",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 357,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#009D81"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_356_3625)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 209,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.5,
    y: 209.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#009D81",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363,
    y: 216,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#009D81"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_356_3625)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 342,
    y: 295,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.5,
    y: 295.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#009D81",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349,
    y: 302,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#009D81"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_356_3625)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 105,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.5,
    y: 105.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#009D81",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 112,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#009D81"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_356_3625)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 295,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.5,
    y: 295.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#009D81",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 302,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#009D81"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_356_3625)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 136,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.5,
    y: 136.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#009D81",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 143,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#009D81"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_356_3625)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 209,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.5,
    y: 209.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#009D81",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 216,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#009D81"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_356_3625)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 28,
    width: 63,
    height: 63,
    rx: 31.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.433 46.958H146.567C149.26 46.958 151.37 46.958 153.017 47.1794C154.703 47.406 156.033 47.8789 157.077 48.9228C158.12 49.9668 158.593 51.2968 158.82 52.9823C159.041 54.6291 159.041 56.7396 159.041 59.4327V59.5666C159.041 62.2597 159.041 64.3703 158.82 66.017C158.593 67.7025 158.12 69.0326 157.077 70.0765C156.033 71.1205 154.703 71.5934 153.017 71.82C151.37 72.0414 149.26 72.0414 146.567 72.0413H146.433C143.74 72.0414 141.629 72.0414 139.982 71.82C138.297 71.5934 136.967 71.1205 135.923 70.0765C134.879 69.0326 134.406 67.7025 134.179 66.017C133.958 64.3703 133.958 62.2597 133.958 59.5666V59.4327C133.958 56.7396 133.958 54.6291 134.179 52.9823C134.406 51.2968 134.879 49.9668 135.923 48.9228C136.967 47.8789 138.297 47.406 139.982 47.1794C141.629 46.958 143.74 46.958 146.433 46.958ZM140.216 48.9138C138.724 49.1143 137.825 49.4957 137.16 50.1603C136.496 50.8249 136.114 51.724 135.914 53.2155C135.71 54.7322 135.708 56.7251 135.708 59.4997C135.708 62.2743 135.71 64.2672 135.914 65.7838C136.114 67.2753 136.496 68.1745 137.16 68.8391C137.825 69.5037 138.724 69.885 140.216 70.0856C141.732 70.2895 143.725 70.2913 146.5 70.2913C149.274 70.2913 151.267 70.2895 152.784 70.0856C154.275 69.885 155.174 69.5037 155.839 68.8391C156.504 68.1745 156.885 67.2753 157.086 65.7838C157.289 64.2672 157.291 62.2743 157.291 59.4997C157.291 56.7251 157.289 54.7322 157.086 53.2155C156.885 51.724 156.504 50.8249 155.839 50.1603C155.174 49.4957 154.275 49.1143 152.784 48.9138C151.267 48.7099 149.274 48.708 146.5 48.708C143.725 48.708 141.732 48.7099 140.216 48.9138Z",
    fill: "#009D81"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.833 52.208C142.316 52.208 142.708 52.5997 142.708 53.083L142.708 54.5413H144.166C144.65 54.5413 145.041 54.9331 145.041 55.4163C145.041 55.8996 144.65 56.2913 144.166 56.2913H142.708V57.7496C142.708 58.2329 142.316 58.6246 141.833 58.6246C141.35 58.6246 140.958 58.2329 140.958 57.7496V56.2913H139.5C139.016 56.2913 138.625 55.8996 138.625 55.4163C138.625 54.9331 139.016 54.5413 139.5 54.5413H140.958L140.958 53.083C140.958 52.5997 141.35 52.208 141.833 52.208ZM147.958 55.4163C147.958 54.9331 148.35 54.5413 148.833 54.5413H153.5C153.983 54.5413 154.375 54.9331 154.375 55.4163C154.375 55.8996 153.983 56.2913 153.5 56.2913H148.833C148.35 56.2913 147.958 55.8996 147.958 55.4163ZM147.958 62.4163C147.958 61.9331 148.35 61.5413 148.833 61.5413H153.5C153.983 61.5413 154.375 61.9331 154.375 62.4163C154.375 62.8996 153.983 63.2913 153.5 63.2913H148.833C148.35 63.2913 147.958 62.8996 147.958 62.4163ZM139.464 61.7976C139.806 61.4559 140.36 61.4559 140.702 61.7976L141.833 62.9289L142.964 61.7976C143.306 61.4559 143.86 61.4559 144.202 61.7976C144.543 62.1393 144.543 62.6934 144.202 63.0351L143.07 64.1663L144.202 65.2976C144.543 65.6393 144.543 66.1933 144.202 66.535C143.86 66.8768 143.306 66.8768 142.964 66.535L141.833 65.4038L140.702 66.5351C140.36 66.8768 139.806 66.8768 139.464 66.5351C139.123 66.1933 139.123 65.6393 139.464 65.2976L140.596 64.1663L139.464 63.0351C139.123 62.6934 139.123 62.1393 139.464 61.7976ZM147.958 65.9163C147.958 65.4331 148.35 65.0413 148.833 65.0413H153.5C153.983 65.0413 154.375 65.4331 154.375 65.9163C154.375 66.3996 153.983 66.7913 153.5 66.7913H148.833C148.35 66.7913 147.958 66.3996 147.958 65.9163Z",
    fill: "#009D81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.589 47.8923L140.308 48.239C139.869 48.2599 139.435 48.3409 139.019 48.4798C138.565 48.6311 138.136 48.8494 137.747 49.1274L137.641 49.2026C136.154 50.265 135.271 51.9803 135.271 53.808V55.708V65.8788C135.271 66.9396 135.643 67.9668 136.322 68.7817C137.053 69.6585 138.088 70.2275 139.219 70.3751L145.572 71.2037C146.863 71.3722 148.174 71.3338 149.453 71.0901L152.249 70.5576C154.993 70.0349 157.223 68.0381 158.044 65.3684C158.318 64.4775 158.425 63.5436 158.359 62.6139L157.718 53.6493C157.631 52.4291 157.154 51.2692 156.358 50.3404C155.456 49.2882 154.203 48.5999 152.831 48.404L150.068 48.0093C149.247 47.892 148.417 47.8529 147.589 47.8923Z",
    fill: "#009D81",
    fillOpacity: 0.2
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_356_3625)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 349,
    y: 35,
    width: 70,
    height: 70,
    rx: 35,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.722 56.7224C368.444 59.0005 368.444 62.6669 368.444 69.9999C368.444 77.3328 368.444 80.9993 370.722 83.2774C373 85.5554 376.667 85.5554 384 85.5554C391.333 85.5554 394.999 85.5554 397.277 83.2774C399.555 80.9993 399.555 77.3328 399.555 69.9999C399.555 62.6669 399.555 59.0005 397.277 56.7224C394.999 54.4443 391.333 54.4443 384 54.4443C376.667 54.4443 373 54.4443 370.722 56.7224ZM375.326 66.1419C375.738 65.6469 376.474 65.5801 376.969 65.9926L377.399 66.3509C378.34 67.135 379.141 67.8025 379.696 68.4165C380.284 69.0686 380.744 69.8186 380.744 70.7777C380.744 71.7368 380.284 72.4868 379.696 73.1389C379.141 73.7529 378.34 74.4204 377.399 75.2045L376.969 75.5628C376.474 75.9753 375.738 75.9085 375.326 75.4135C374.913 74.9185 374.98 74.1828 375.475 73.7703L375.84 73.4665C376.864 72.6128 377.534 72.0509 377.964 71.5751C378.372 71.1233 378.411 70.9114 378.411 70.7777C378.411 70.644 378.372 70.4321 377.964 69.9803C377.534 69.5045 376.864 68.9426 375.84 68.0889L375.475 67.7851C374.98 67.3726 374.913 66.6369 375.326 66.1419ZM392.944 74.6666C392.944 75.3109 392.422 75.8333 391.778 75.8333H384C383.356 75.8333 382.833 75.3109 382.833 74.6666C382.833 74.0223 383.356 73.4999 384 73.4999H391.778C392.422 73.4999 392.944 74.0223 392.944 74.6666Z",
    fill: "#F44336"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 384,
    width: 228,
    height: 67,
    rx: 33.5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171.051 409.138C173.227 409.138 175.017 409.908 176.467 411.427C177.917 412.968 178.642 414.848 178.642 417.069C178.642 419.29 177.917 421.17 176.467 422.711C175.017 424.252 173.227 425 171.051 425H164.82V409.138H171.051ZM171.051 422.507C172.547 422.507 173.748 422.009 174.7 420.967C175.651 419.947 176.127 418.655 176.127 417.069C176.127 415.483 175.651 414.191 174.7 413.171C173.748 412.152 172.547 411.631 171.051 411.631H167.426V422.507H171.051ZM189.833 413.67H192.28V425H189.833V423.368C188.904 424.66 187.59 425.295 185.867 425.295C184.304 425.295 182.967 424.728 181.879 423.572C180.769 422.417 180.225 421.012 180.225 419.335C180.225 417.658 180.769 416.253 181.879 415.098C182.967 413.965 184.304 413.375 185.867 413.375C187.59 413.375 188.904 414.01 189.833 415.279V413.67ZM186.253 422.961C187.272 422.961 188.133 422.621 188.813 421.941C189.493 421.261 189.833 420.377 189.833 419.335C189.833 418.293 189.493 417.432 188.813 416.752C188.133 416.072 187.272 415.709 186.253 415.709C185.21 415.709 184.372 416.072 183.692 416.752C183.012 417.432 182.672 418.293 182.672 419.335C182.672 420.377 183.012 421.261 183.692 421.941C184.372 422.621 185.21 422.961 186.253 422.961ZM201.455 416.027H198.645V421.465C198.645 421.941 198.736 422.281 198.962 422.485C199.166 422.689 199.483 422.802 199.891 422.825C200.299 422.847 200.82 422.847 201.455 422.802V425C199.574 425.227 198.237 425.068 197.421 424.524C196.606 423.98 196.198 422.961 196.198 421.465V416.027H194.113V413.67H196.198V411.223L198.645 410.498V413.67H201.455V416.027ZM212.183 413.67H214.63V425H212.183V423.368C211.254 424.66 209.94 425.295 208.218 425.295C206.654 425.295 205.317 424.728 204.23 423.572C203.119 422.417 202.575 421.012 202.575 419.335C202.575 417.658 203.119 416.253 204.23 415.098C205.317 413.965 206.654 413.375 208.218 413.375C209.94 413.375 211.254 414.01 212.183 415.279V413.67ZM208.603 422.961C209.623 422.961 210.484 422.621 211.163 421.941C211.843 421.261 212.183 420.377 212.183 419.335C212.183 418.293 211.843 417.432 211.163 416.752C210.484 416.072 209.623 415.709 208.603 415.709C207.561 415.709 206.722 416.072 206.042 416.752C205.363 417.432 205.023 418.293 205.023 419.335C205.023 420.377 205.363 421.261 206.042 421.941C206.722 422.621 207.561 422.961 208.603 422.961Z",
    fill: "#272A39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M230.807 425.295C228.405 425.295 226.434 424.524 224.87 422.938C223.284 421.352 222.513 419.403 222.513 417.069C222.513 414.758 223.284 412.809 224.87 411.223C226.434 409.637 228.405 408.843 230.807 408.843C232.235 408.843 233.549 409.183 234.773 409.863C235.996 410.543 236.948 411.472 237.628 412.628L235.362 413.942C234.931 413.171 234.319 412.537 233.504 412.084C232.688 411.631 231.804 411.381 230.807 411.381C229.108 411.381 227.725 411.925 226.683 412.99C225.641 414.078 225.119 415.437 225.119 417.069C225.119 418.723 225.641 420.083 226.683 421.148C227.725 422.235 229.108 422.757 230.807 422.757C231.804 422.757 232.71 422.53 233.526 422.077C234.342 421.624 234.954 420.989 235.362 420.196L237.628 421.488C236.948 422.666 236.019 423.595 234.795 424.275C233.572 424.955 232.257 425.295 230.807 425.295ZM239.745 425V408.458H242.192V425H239.745ZM246.96 420.377C247.141 421.238 247.549 421.918 248.206 422.371C248.84 422.825 249.633 423.051 250.585 423.051C251.877 423.051 252.851 422.598 253.508 421.646L255.525 422.825C254.392 424.479 252.738 425.295 250.562 425.295C248.704 425.295 247.231 424.751 246.098 423.618C244.965 422.485 244.399 421.057 244.399 419.335C244.399 417.658 244.943 416.231 246.076 415.098C247.186 413.965 248.614 413.375 250.381 413.375C252.035 413.375 253.395 413.965 254.46 415.12C255.525 416.299 256.069 417.703 256.069 419.358C256.069 419.63 256.024 419.969 255.978 420.377H246.96ZM246.937 418.383H253.599C253.418 417.477 253.032 416.774 252.443 416.299C251.854 415.845 251.152 415.596 250.359 415.596C249.452 415.596 248.682 415.845 248.093 416.344C247.481 416.842 247.096 417.522 246.937 418.383ZM267.129 413.67H269.577V425H267.129V423.368C266.2 424.66 264.886 425.295 263.164 425.295C261.6 425.295 260.263 424.728 259.176 423.572C258.065 422.417 257.521 421.012 257.521 419.335C257.521 417.658 258.065 416.253 259.176 415.098C260.263 413.965 261.6 413.375 263.164 413.375C264.886 413.375 266.2 414.01 267.129 415.279V413.67ZM263.549 422.961C264.569 422.961 265.43 422.621 266.11 421.941C266.789 421.261 267.129 420.377 267.129 419.335C267.129 418.293 266.789 417.432 266.11 416.752C265.43 416.072 264.569 415.709 263.549 415.709C262.507 415.709 261.668 416.072 260.988 416.752C260.309 417.432 259.969 418.293 259.969 419.335C259.969 420.377 260.309 421.261 260.988 421.941C261.668 422.621 262.507 422.961 263.549 422.961ZM278.389 413.375C279.68 413.375 280.723 413.806 281.538 414.622C282.331 415.46 282.739 416.593 282.739 418.043V425H280.292V418.293C280.292 417.454 280.065 416.797 279.612 416.344C279.159 415.891 278.525 415.664 277.754 415.664C276.893 415.664 276.191 415.936 275.669 416.48C275.126 417.024 274.876 417.839 274.876 418.927V425H272.429V413.67H274.876V415.12C275.601 413.965 276.78 413.375 278.389 413.375ZM287.572 416.797C287.572 417.182 287.776 417.477 288.184 417.703C288.592 417.93 289.113 418.111 289.703 418.27C290.292 418.429 290.903 418.61 291.515 418.814C292.104 419.04 292.626 419.403 293.034 419.901C293.441 420.4 293.668 421.034 293.668 421.805C293.668 422.893 293.237 423.754 292.399 424.366C291.561 425 290.518 425.295 289.249 425.295C288.116 425.295 287.165 425.068 286.371 424.592C285.556 424.139 284.989 423.482 284.627 422.643L286.734 421.42C287.119 422.507 287.958 423.051 289.249 423.051C290.518 423.051 291.175 422.643 291.175 421.782C291.175 421.42 290.949 421.125 290.541 420.899C290.133 420.672 289.612 420.491 289.023 420.332C288.434 420.173 287.822 419.992 287.233 419.766C286.621 419.562 286.1 419.222 285.692 418.723C285.284 418.225 285.08 417.613 285.08 416.842C285.08 415.8 285.465 414.962 286.258 414.327C287.051 413.693 288.048 413.375 289.227 413.375C290.156 413.375 290.994 413.602 291.719 414.01C292.444 414.418 293.011 415.007 293.419 415.732L291.357 416.888C290.949 416.027 290.246 415.596 289.227 415.596C288.751 415.596 288.366 415.709 288.048 415.913C287.731 416.117 287.572 416.412 287.572 416.797ZM296.91 411.97C296.48 411.97 296.117 411.835 295.8 411.517C295.483 411.2 295.347 410.838 295.347 410.407C295.347 409.999 295.483 409.637 295.8 409.319C296.094 409.002 296.457 408.843 296.91 408.843C297.341 408.843 297.703 409.002 298.021 409.319C298.315 409.637 298.474 409.999 298.474 410.407C298.474 410.838 298.315 411.2 297.998 411.517C297.681 411.835 297.318 411.97 296.91 411.97ZM295.687 425V413.67H298.134V425H295.687ZM306.935 413.375C308.227 413.375 309.269 413.806 310.085 414.622C310.878 415.46 311.286 416.593 311.286 418.043V425H308.838V418.293C308.838 417.454 308.612 416.797 308.159 416.344C307.705 415.891 307.071 415.664 306.3 415.664C305.439 415.664 304.737 415.936 304.216 416.48C303.672 417.024 303.423 417.839 303.423 418.927V425H300.975V413.67H303.423V415.12C304.148 413.965 305.326 413.375 306.935 413.375ZM322.939 413.67H325.341V424.479C325.341 426.201 324.775 427.538 323.642 428.444C322.509 429.373 321.127 429.827 319.518 429.827C316.889 429.827 315.099 428.92 314.147 427.085L316.255 425.861C316.844 427.039 317.932 427.606 319.563 427.606C320.605 427.606 321.444 427.334 322.033 426.79C322.622 426.246 322.939 425.476 322.939 424.479V423.097C322.01 424.411 320.696 425.068 318.997 425.068C317.388 425.068 316.028 424.501 314.94 423.368C313.83 422.235 313.286 420.853 313.286 419.222C313.286 417.613 313.83 416.231 314.94 415.098C316.028 413.965 317.388 413.375 318.997 413.375C320.696 413.375 322.01 414.033 322.939 415.347V413.67ZM319.336 422.779C320.356 422.779 321.217 422.439 321.897 421.76C322.577 421.08 322.939 420.241 322.939 419.222C322.939 418.225 322.577 417.364 321.897 416.684C321.217 416.004 320.356 415.664 319.336 415.664C318.294 415.664 317.433 416.004 316.753 416.684C316.073 417.364 315.734 418.225 315.734 419.222C315.734 420.241 316.073 421.08 316.753 421.76C317.433 422.439 318.294 422.779 319.336 422.779Z",
    fill: "#F44336"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_356_3625)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 350,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.5,
    y: 350.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#009D81",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197,
    y: 357,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#009D81"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_356_3625)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 266,
    width: 84,
    height: 84,
    rx: 42,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.5 308C449.5 317.665 441.665 325.5 432 325.5C422.335 325.5 414.5 317.665 414.5 308C414.5 298.335 422.335 290.5 432 290.5C441.665 290.5 449.5 298.335 449.5 308ZM434.604 298.28C435.304 298.468 435.72 299.188 435.532 299.888L431.003 316.792C430.815 317.492 430.096 317.907 429.395 317.72C428.695 317.532 428.28 316.812 428.467 316.112L432.997 299.208C433.184 298.508 433.904 298.093 434.604 298.28ZM437.197 301.822C437.709 301.309 438.541 301.309 439.053 301.822L439.418 302.187C440.529 303.298 441.457 304.225 442.094 305.06C442.766 305.942 443.238 306.873 443.238 308C443.238 309.127 442.766 310.058 442.094 310.94C441.457 311.775 440.53 312.702 439.418 313.813L439.053 314.178C438.541 314.691 437.709 314.691 437.197 314.178C436.684 313.666 436.684 312.834 437.197 312.322L437.497 312.022C438.69 310.829 439.489 310.025 440.007 309.347C440.501 308.7 440.613 308.323 440.613 308C440.613 307.677 440.501 307.3 440.007 306.653C439.489 305.975 438.69 305.171 437.497 303.978L437.197 303.678C436.684 303.166 436.684 302.334 437.197 301.822ZM424.947 301.822C425.46 301.309 426.291 301.309 426.803 301.822C427.316 302.334 427.316 303.166 426.803 303.678L426.503 303.978C425.31 305.171 424.511 305.975 423.994 306.653C423.499 307.3 423.388 307.677 423.388 308C423.388 308.323 423.499 308.7 423.994 309.347C424.511 310.025 425.31 310.829 426.503 312.022L426.803 312.322C427.316 312.834 427.316 313.666 426.803 314.178C426.291 314.691 425.46 314.691 424.947 314.178L424.583 313.813C423.471 312.702 422.544 311.775 421.907 310.94C421.234 310.058 420.763 309.127 420.763 308C420.763 306.873 421.234 305.942 421.907 305.06C422.544 304.225 423.471 303.298 424.583 302.187L424.947 301.822Z",
    fill: "#009D81"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_356_3625)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 302,
    width: 66,
    height: 66,
    rx: 33,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.5946 324.759L72.9942 330.358L72.1515 329.521C71.1459 328.522 70.9353 328.369 70.2382 328.131C69.4344 327.857 68.5798 327.852 67.8105 328.116C67.217 328.319 66.8051 328.612 65.9164 329.464C65.6688 329.701 63.5837 331.347 60.3659 333.847C55.402 337.702 54.1602 338.681 54.1602 338.736C54.1602 338.75 56.8786 341.479 60.2012 344.801L66.2423 350.84L66.5169 350.509C66.9341 350.005 67.2173 349.651 67.825 348.869C68.1303 348.477 69.0754 347.264 69.9252 346.174C70.775 345.084 71.9777 343.541 72.5979 342.745C74.9524 339.724 74.8257 339.877 75.6108 339.12C76.0142 338.731 76.4137 338.313 76.4984 338.191C77.0971 337.327 77.3157 336.161 77.0638 335.174C76.8495 334.335 76.6376 334.022 75.5046 332.873L74.6232 331.98L80.2317 326.373L85.8402 320.766L85.0378 319.963C84.5965 319.521 84.2263 319.16 84.2152 319.16C84.204 319.16 81.6748 321.68 78.5946 324.759ZM69.6673 330.328C69.8932 330.44 70.1849 330.718 72.3248 332.863C75.0489 335.595 74.8773 335.381 74.8773 336.046C74.8773 336.387 74.8654 336.448 74.751 336.689C74.6261 336.953 74.2962 337.354 74.2044 337.354C74.1687 337.354 68.8167 332.039 67.8608 331.054L67.7038 330.893L67.9203 330.673C68.3181 330.268 68.5406 330.174 69.0528 330.191C69.3641 330.201 69.4484 330.22 69.6673 330.328ZM69.3193 335.683L72.6428 339.005L72.1319 339.656C71.8509 340.014 71.1949 340.851 70.6741 341.516C70.1533 342.181 69.5104 343.002 69.2455 343.34C68.9805 343.678 68.303 344.543 67.7399 345.262C67.1768 345.982 66.5638 346.763 66.3776 346.998L66.0392 347.426L65.235 346.623L64.4308 345.819L64.563 345.68C64.6356 345.603 65.1803 345.033 65.7732 344.414L66.8514 343.288L66.2252 342.688C65.8809 342.358 65.5165 342.012 65.4156 341.92L65.232 341.753L64.4045 342.615C63.9494 343.089 63.4126 343.647 63.2115 343.854L62.846 344.232L62.1124 343.498L61.3786 342.765L63.5364 340.585C64.7231 339.386 65.6951 338.394 65.6962 338.38C65.6973 338.366 65.3489 338.004 64.9218 337.576L64.1452 336.796L61.9663 338.958C60.7679 340.147 59.7746 341.12 59.7589 341.12C59.7433 341.12 59.2399 340.629 58.6403 340.029C57.5576 338.945 57.5508 338.937 57.6363 338.869C57.6837 338.832 58.0406 338.553 58.4293 338.249C58.8181 337.945 59.2968 337.569 59.4931 337.414C59.6893 337.259 60.3852 336.713 61.0394 336.201C61.6936 335.689 62.7285 334.878 63.3391 334.4C65.3303 332.839 65.9491 332.36 65.9727 332.36C65.9854 332.36 67.4914 333.855 69.3193 335.683Z",
    fill: "#F44336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_356_3625",
    x: 287,
    y: 114,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0 0.741176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_356_3625",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_356_3625",
    x: 250,
    y: 328,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0 0.741176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_356_3625",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_356_3625",
    x: 328,
    y: 187,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0 0.741176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_356_3625",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_356_3625",
    x: 314,
    y: 273,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0 0.741176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_356_3625",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_356_3625",
    x: 205,
    y: 83,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0 0.741176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_356_3625",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_356_3625",
    x: 97,
    y: 273,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0 0.741176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_356_3625",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_356_3625",
    x: 126,
    y: 114,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0 0.741176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_356_3625",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_356_3625",
    x: 82,
    y: 187,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0 0.741176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_356_3625",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_356_3625",
    x: 79.72,
    y: 0.279997,
    width: 148.68,
    height: 148.68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.52,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7.56,
    dy: 15.12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0 0.741176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_356_3625",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_356_3625",
    x: 309.8,
    y: 4.2,
    width: 165.2,
    height: 165.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.8,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.4,
    dy: 16.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0 0.741176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_356_3625",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_356_3625",
    x: 162,
    y: 328,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0 0.741176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_356_3625",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_356_3625",
    x: 342.96,
    y: 229.04,
    width: 198.24,
    height: 198.24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.36,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10.08,
    dy: 20.16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.88
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0 0.741176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_356_3625",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_356_3625",
    x: 0.0400023,
    y: 272.96,
    width: 155.76,
    height: 155.76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.64,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7.92,
    dy: 15.84
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0 0.741176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_356_3625"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_356_3625",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle4);
export default __webpack_public_path__ + "static/media/circle-4.3c1f83b647ea1ff599154557e6136fc4.svg";
export { ForwardRef as ReactComponent };